import { getClosestFocusableNodeInDirection } from "./getClosestFocusableNodeInDirection.js";
export default function getPreferredNode({ nodes, focusOrigin, direction }) {
    if (!focusOrigin || !direction) {
        // pick the child that was mounted first
        return nodes.values().next().value;
    }
    const preferredFocusableNode = getClosestFocusableNodeInDirection(nodes, focusOrigin.getBoundingBox(), direction);
    if (!preferredFocusableNode) {
        // pick the child that was mounted first
        return nodes.values().next().value;
    }
    return preferredFocusableNode;
}
